import { Button, CircularProgress, Checkbox, Typography } from "@material-ui/core";
import ArrowBackIosNewIcon from "@material-ui/icons/ArrowBackIos";
import InfoIcon from "@material-ui/icons/Info";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AccessTimeFilledIcon from "@material-ui/icons/AccessTimeOutlined";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import TuneIcon from "@material-ui/icons/Tune";
import CloseIcon from "@material-ui/icons/Close";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTable, usePagination } from "react-table";
import translate from "../../../../i18n/translate";
import "./reactTable.scss";
import { optionConstants } from "../../VocabularyCenter/optionConstants";
import DialogView from "../DialogContents";
import {
  getVocabularyContents,
  vocabularyDeleteWordList,
  vocabularyUpdateWordList,
} from "../../../../redux/actions/vocabularyCenterAction";
import { USER } from "../../../../redux/constants";

export const getStandardHeaderView = (text: any, closeFn: any) => {
  return (
    <div className="standard-view-header-box">
      <Typography className="standard-view-text">{text}</Typography>
      <CloseIcon className="standard-view-close-icon" onClick={closeFn} />
    </div>
  );
};

const ReactTable = ({ setInfoDetails, isUserWordList, showingWordListDetails, setShowWords, changeView }: any) => {
  const WORDLIST_REGEX = /^[ A-Za-z0-9()-.;:?!&]*$/;
  const dispatch = useDispatch();
  const reduxState = useSelector((state: any) => state);
  const [topicLevelWords, setTopicLevelWords] = React.useState<any>([]);
  const [tableBodyContents, setTableBodyContents] = React.useState<any>([]);
  const [showNoWordsMessage, setShowNoWordsMessage] = React.useState<boolean>(false);
  const [selectedHeaderLabels, setSelectedHeaderLabels] = React.useState<any>([]);
  const [showOptions, setShowOptions] = React.useState<boolean>(false);
  const [, updateState] = React.useState<any>();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  let isPlaying = false;
  const [showEdit, setShowEdit] = React.useState<boolean>(false);
  const [editableWordList, setEditableWordList] = React.useState<any>("");
  const [showDelete, setShowDelete] = React.useState<boolean>(false);
  const [showError, setShowError] = React.useState<boolean>(false);
  const [alreadyExistsMessage, setAlreadyExistsMessage] = React.useState<boolean>(false);
  const [isMobileWith, setIsMobileWidth] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (window.innerWidth <= 800) {
      setIsMobileWidth(true);
    } else {
      setIsMobileWidth(false);
    }
  }, []);

  React.useEffect(() => {
    if (
      reduxState.vocabularyContents &&
      reduxState.vocabularyContents.topicLevelContent &&
      Object.keys(reduxState.vocabularyContents.topicLevelContent).length > 0
    ) {
      setTopicLevelWords(reduxState.vocabularyContents.topicLevelContent.wordlist);
    } else {
      setTopicLevelWords([]);
    }
  }, [reduxState]);

  React.useEffect(() => {
    if (topicLevelWords && topicLevelWords.length > 0) {
      setShowNoWordsMessage(false);
      const framedState: any = [];
      topicLevelWords.forEach((wordDetails: any) => {
        if (wordDetails) {
          framedState.push({
            word: wordDetails.word.replace(/<\/?[^>]+(>|$)/g, ""),
            translation:
              wordDetails.translation === null || wordDetails.translation === ""
                ? ""
                : wordDetails.translation[0]
                ? wordDetails.translation[0].word.replace(/<\/?[^>]+(>|$)/g, "")
                : "",
            pos: wordDetails.pos.replace(/<\/?[^>]+(>|$)/g, ""),
            definition: wordDetails.definition.replace(/<\/?[^>]+(>|$)/g, ""),
            sentence: wordDetails.sentence.replace(/<\/?[^>]+(>|$)/g, ""),

            audioPath: wordDetails.audioPath,
            sentenceAudio: wordDetails.sentenceAudio,
            notes: wordDetails.notes,
            noteId: wordDetails.noteId,
            defId: wordDetails.defId,
            listId: wordDetails.listId,
            posId: wordDetails.posId,
            wordId: wordDetails.wordId,
            wordlist: wordDetails.wordlist,
            isDeletable: isDeletable(wordDetails),
          });
        }
      });
      setTableBodyContents(framedState);
    } else {
      setShowNoWordsMessage(true);
      setTableBodyContents([]);
    }
  }, [topicLevelWords]);

  const frameDefaultCheckBoxOptions = () => {
    return optionConstants.map((optionConstant: any) => {
      return {
        checked: true,
        name: optionConstant,
      };
    });
  };

  const isDeletable = (wordDetails: any) => {
    const usersWordList = reduxState.vocabularyContents.headerLevelContents.User["userWordlists"];
    if (usersWordList && usersWordList.length > 0) {
      const isAvailableInUsersList = usersWordList.findIndex((userList: any) => userList.listId === wordDetails.listId);
      return isAvailableInUsersList !== -1;
    }
  };

  const data = React.useMemo(() => tableBodyContents, [tableBodyContents]);

  const columns: any = React.useMemo(
    () => [
      {
        Header: translate("vocab_center_word_label"),
        accessor: "word",
        Cell: (props: any) => (
          <div className="audio-container">
            {props.cell.row.original.audioPath !== "" && (
              <VolumeUpIcon
                className="audio-icon"
                onClick={() => {
                  const audioTag = document.createElement("audio");
                  audioTag.src = `${process.env.REACT_APP_PROGRESS_URL}/content/${changeFormat(
                    props.cell.row.original.audioPath
                  )}`;
                  if (!isPlaying) {
                    audioTag.play();
                  }
                  audioTag.addEventListener("play", () => {
                    isPlaying = true;
                  });
                  audioTag.addEventListener("ended", () => {
                    isPlaying = false;
                  });
                }}
              />
            )}
            <p className="audio-icon-label">{props.cell.value}</p>
          </div>
        ),
      },
      {
        Header: translate("vocab_center_translation_label"),
        accessor: "translation",
      },
      {
        Header: translate("vocab_center_pos_label"),
        accessor: "pos",
      },
      {
        Header: translate("vocab_center_definition_label"),
        accessor: "definition",
      },
      {
        Header: translate("vocab_center_sentence_label"),
        accessor: "sentence",
        Cell: (props: any) => (
          <div className="audio-container">
            {props.cell.row.original.sentenceAudio !== "" && (
              <VolumeUpIcon
                className="audio-icon"
                onClick={() => {
                  const audioTag = document.createElement("audio");
                  audioTag.src = `${process.env.REACT_APP_PROGRESS_URL}/content/${changeFormat(
                    props.cell.row.original.sentenceAudio
                  )}`;
                  if (!isPlaying) {
                    audioTag.play();
                  }
                  audioTag.addEventListener("play", () => {
                    isPlaying = true;
                  });
                  audioTag.addEventListener("ended", () => {
                    isPlaying = false;
                  });
                }}
              />
            )}
            <p className="audio-icon-label">{props.cell.value}</p>
          </div>
        ),
      },
    ],
    [selectedHeaderLabels]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex },
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: selectedHeaderLabels,
      },
    },
    usePagination
  );

  const changeFormat = (url: any) => {
    return url.replace(".wav", ".mp3");
  };

  const simplifyLabels = (label: any) => {
    switch (label) {
      case "Word":
        return "word";
      case "Translation":
        return "translation";
      case "Parts of Speech":
        return "pos";
      case "Definition":
        return "definition";
      case "Sentence":
        return "sentence";
    }
  };

  const [selectedFilters, setSelectedFilters] = React.useState<any>(frameDefaultCheckBoxOptions());

  const isDisabledChecked = () => {
    const isChecked = selectedFilters.filter((filterKey: any) => filterKey.checked === true);
    if (isChecked.length === 1) {
      return isChecked[0].name;
    } else {
      return "";
    }
  };

  const isFilterChecked = (optionKey: any) => {
    const isChecked = selectedFilters.filter((filterKey: any) => filterKey.name === optionKey);
    if (isChecked.length > 0) {
      return isChecked[0].checked;
    } else {
      return false;
    }
  };

  const handleCheckedOptions = (e: any) => {
    const isAvailable = selectedFilters.findIndex((filterOption: any) => filterOption.name === e.target.name);
    if (isAvailable !== -1) {
      selectedFilters[isAvailable].checked = e.target.checked;
    }
    setSelectedFilters(selectedFilters);
    const selectedHeaders = selectedFilters.map((filter: any) => (filter.checked ? "" : simplifyLabels(filter.name)));
    setSelectedHeaderLabels(selectedHeaders);
    forceUpdate();
  };

  const getOptionsView = () => {
    return (
      <>
        <div className="options-container">
          {optionConstants.map((option: any) => (
            <div className="option-filter-type">
              <Checkbox
                checked={isFilterChecked(option)}
                onChange={handleCheckedOptions}
                className="option-filter-checkbox"
                name={option}
                disabled={isDisabledChecked() === option}
              />
              <p className="option-label">{option}</p>
            </div>
          ))}
        </div>
        <div className="option-filter-button-box">
          <Button
            variant="contained"
            className="option-filter-button-text"
            disabled={checkUnCheckedCount()}
            onClick={() => setShowOptions(false)}
          >
            {translate("vocab_center_okay_text")}
          </Button>
        </div>
      </>
    );
  };

  const getEditView = () => {
    if (editableWordList.length === 0) {
      setEditableWordList(showingWordListDetails.wordlist);
    }
    return (
      <>
        {getStandardHeaderView(translate("vocab_center_edit_wordlist"), () => {
          setShowEdit(false);
          setEditableWordList("");
        })}
        <div className="edit-view-contents-box">
          <Typography className="edit-view-edit-label">{translate("vocab_center_update_wordlist")}:</Typography>
          <input
            className="word-list-input"
            maxLength={40}
            value={editableWordList}
            onChange={(e) => {
              setShowError(!WORDLIST_REGEX.test(e.target.value));
              setEditableWordList(e.target.value);
              setAlreadyExistsMessage(false);
            }}
          />
        </div>
        {showError && <p className="show-error-message">Please enter a-z,A-Z,0-9,()-.,;:?!&</p>}
        {alreadyExistsMessage && (
          <div className="already-exists-container">
            <AccessTimeFilledIcon className="history-icon" />
            <p className="already-exists-label">{translate("vocab_center_word_exists_in_wordlist_warning_message")}.</p>
          </div>
        )}
        <div className="word-list-action-box">
          <Button
            variant="contained"
            className="word-list-action-button"
            onClick={() => handleWordListActions(showingWordListDetails.listId)}
            disabled={
              alreadyExistsMessage ||
              reduxState.vocabularyContents.isWordListCreating ||
              reduxState.vocabularyContents.isWordListUpdating ||
              editableWordList.length === 0 ||
              showError
            }
          >
            {translate("vocab_center_save_text")}
          </Button>
          <Button
            variant="contained"
            className="word-list-action-button"
            onClick={() => {
              setShowEdit(false);
              setEditableWordList("");
            }}
          >
            {translate("vocab_center_close_text")}
          </Button>
        </div>
      </>
    );
  };

  const getDeleteView = () => {
    return (
      <>
        {getStandardHeaderView(translate("vocab_center_delete_wordlist"), () => {
          setShowDelete(false);
        })}
        <div className="delete-view-contents-box">
          <Typography>{translate("vocab_center_delete_wordlist_warning_message")}</Typography>
          <div className="delete-view-contents-actions">
            <Button variant="contained" className="word-list-action-button" onClick={deleteWordList}>
              {translate("vocab_center_yes_text")}
            </Button>
            <Button variant="contained" className="word-list-action-button" onClick={() => setShowDelete(false)}>
              {translate("vocab_center_close_text")}
            </Button>
          </div>
        </div>
      </>
    );
  };

  const deleteWordList = () => {
    const deletableListId = tableBodyContents[0].listId;
    dispatch(vocabularyDeleteWordList(reduxState.peopleInformation.data.getpeopleInformation.token, deletableListId));
    setShowDelete(false);
    setShowWords(false);
    setTimeout(() => {
      getVocabularyContentsDetails();
    }, 500);
  };

  const getVocabularyContentsDetails = () => {
    const peopleInfoStateValidation = reduxState.peopleInformation ? reduxState.peopleInformation.data : "";
    dispatch(
      getVocabularyContents(
        reduxState.common.lgId,
        peopleInfoStateValidation.getpeopleInformation.token,
        parseInt(peopleInfoStateValidation.getpeopleInformation.accountId, 10)
      )
    );
  };

  const handleWordListActions = (listId: any) => {
    dispatch(
      vocabularyUpdateWordList(
        reduxState.peopleInformation.data.getpeopleInformation.token,
        listId,
        editableWordList,
        USER
      )
    );
    setTimeout(() => {
      getVocabularyContentsDetails();
      setShowEdit(false);
    }, 2000);
  };

  // Used to validate the checked count
  const checkUnCheckedCount = () => {
    const unCheckedSegments = selectedFilters.filter((filterOption: any) => !filterOption.checked);
    if (unCheckedSegments.length === optionConstants.length) {
      return true;
    } else {
      return false;
    }
  };

  return reduxState.vocabularyContents.isSubTopicLoading ? (
    <div className="loader-wrapper">
      <CircularProgress color="primary" className="circularLoader" size={100} />
    </div>
  ) : showNoWordsMessage ? (
    <div className="no-data-table-body-contents">
      {!reduxState.vocabularyContents.isLoading && !reduxState.vocabularyContents.isSubTopicLoading && (
        <>
          <p className="no-data-message">"{translate("vocab_center_no_word_message")}"</p>
          <div className="back-container" onClick={changeView}>
            <ArrowBackIosNewIcon className="back-icon" />
            <p className="back-label">Back</p>
          </div>
        </>
      )}
    </div>
  ) : !showNoWordsMessage ? (
    <>
      <div className="header-container">
        <div className="back-container" onClick={changeView}>
          <ArrowBackIosNewIcon className="back-icon" />
          <p className="back-label">Back</p>
        </div>
        <div className="filter-button-container">
          {!isMobileWith && (
            <Button className="option-filter-button" onClick={() => setShowOptions(true)}>
              <TuneIcon /> Options
            </Button>
          )}
          {isUserWordList && (
            <Button className="edit-option-button" onClick={() => setShowEdit(true)}>
              <EditIcon /> Edit
            </Button>
          )}
          {isUserWordList && (
            <Button className="delete-option-button" onClick={() => setShowDelete(true)}>
              <DeleteIcon /> Delete
            </Button>
          )}
        </div>
      </div>
      {showOptions && (
        <DialogView
          open={showOptions}
          handleClose={() => setShowOptions(false)}
          dialogContainerClassNameValue="vocabulary-show-options-popup"
          dialogContentsClassName="vocabulary-show-options-popup-contents"
          dialogBody={getOptionsView()}
        />
      )}
      {showEdit && (
        <DialogView
          open={showEdit}
          handleClose={() => setShowEdit(false)}
          dialogContainerClassNameValue="vocabulary-show-edit-popup"
          dialogContentsClassName="vocabulary-show-edit-popup-contents"
          dialogBody={getEditView()}
        />
      )}
      {showDelete && (
        <DialogView
          open={showDelete}
          handleClose={() => setShowDelete(false)}
          dialogContainerClassNameValue="vocabulary-show-delete-popup"
          dialogContentsClassName="vocabulary-show-delete-popup-contents"
          dialogBody={getDeleteView()}
        />
      )}
      {!isMobileWith && (
        <>
          <table {...getTableProps()} className="react-table-container">
            <thead className="react-table-header-container">
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} className="react-table-header-row">
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} className="react-table-header-cell">
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className="react-table-body-container">
              {page.map((row: any) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className="react-table-body-row"
                    onDoubleClick={() => {
                      setInfoDetails(row.original);
                    }}
                  >
                    {row.cells.map((cell: any) => {
                      return (
                        <td {...cell.getCellProps()} className="react-table-row-cell">
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="react-table-pagination">
            <button onClick={() => previousPage()} disabled={!canPreviousPage} className="navigation-button">
              <ArrowBackIcon />
            </button>{" "}
            <span className="pagination-details">
              Page{" "}
              <strong className="main-topic">
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <button onClick={() => nextPage()} disabled={!canNextPage} className="navigation-button">
              <ArrowForwardIcon />
            </button>
          </div>
        </>
      )}
      {isMobileWith && (
        <div className="react-table-mobile-contents">
          {tableBodyContents.map((bodyContent: any) => (
            <div
              className="react-table-each-word"
              key={bodyContent.wordId}
              onClick={() => {
                setInfoDetails(bodyContent);
              }}
            >
              <InfoIcon />
              <p>{bodyContent.word}</p>
            </div>
          ))}
        </div>
      )}
    </>
  ) : (
    <> </>
  );
};

export default ReactTable;
